import React from 'react';
import { Box, Typography } from '@mui/material';
import './DashboardLoader.css';

const DashboardLoader = () => {
  return (
    <Box className="dashboard-loader-container">
      {/* Animated Background */}
      <div className="loader-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      {/* Main Loader Content */}
      <Box className="loader-content">
        {/* Logo/Icon Animation */}
        <div className="loader-icon-wrapper">
          <div className="loader-icon">
            <svg viewBox="0 0 100 100" className="dashboard-icon">
              {/* Dashboard Grid Icon */}
              <rect x="10" y="10" width="35" height="35" rx="4" className="icon-rect rect-1" />
              <rect x="55" y="10" width="35" height="35" rx="4" className="icon-rect rect-2" />
              <rect x="10" y="55" width="35" height="35" rx="4" className="icon-rect rect-3" />
              <rect x="55" y="55" width="35" height="35" rx="4" className="icon-rect rect-4" />
            </svg>
          </div>
          
          {/* Rotating Ring */}
          <div className="loader-ring"></div>
          <div className="loader-ring-2"></div>
        </div>

        {/* Loading Text */}
        <Typography variant="h5" className="loader-title">
          Loading Dashboard
        </Typography>

        {/* Animated Progress Bar */}
        <Box className="progress-bar-container">
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
        </Box>

        {/* Loading Subtitle */}
        <Typography variant="body2" className="loader-subtitle">
          Preparing your data
          <span className="dot-1">.</span>
          <span className="dot-2">.</span>
          <span className="dot-3">.</span>
        </Typography>

        {/* Floating Particles */}
        <div className="particles">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <div className="particle particle-4"></div>
          <div className="particle particle-5"></div>
          <div className="particle particle-6"></div>
        </div>
      </Box>
    </Box>
  );
};

export default DashboardLoader;
